import PasswordResetLinkStyles from "./PasswordResetLink.styles";
import { Box, Grid, Typography } from "@mui/material";
import CustomCard from "../../../../global/components/CustomCard/CustomCard";
import LogoIcon from "../../../../assets/icons/logo-icon.svg";
import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import { ReactComponent as BackButtonIcon } from "../../../../assets/icons/ArrowLeft.svg";
import { Link } from "react-router-dom";
import urls from "../../../../global/constants/UrlConstants";
import history from "../../../../utils/history";

const PasswordResetLink = () => {
  const classes = PasswordResetLinkStyles;

  const handleBackButton = () => {
    history.push(urls.loginViewPath);
  };

  const cardContent = () => {
    return (
      <>
        <Box>
          <Box sx={classes.cardHeader}>
            <img src={LogoIcon} alt="img" />
            <Typography sx={classes.cardTitle}>
              Password Reset Link Send
            </Typography>
            <Typography sx={classes.cardSubText}>
              We've sent you an email with a link to reset your password.
            </Typography>
          </Box>

          <Box sx={classes.cardContent}>
            <Typography sx={classes.cardInfo}>
              Check your spam and promotions folder if it doesn't appear in your
              main mailbox.
            </Typography>
          </Box>

          <Box
            display={"flex"}
            margin={"auto"}
            mt={"18px"}
            sx={{ pointer: "cursor", justifyContent: "center" }}
          >
            <BackButtonIcon />
            <Typography onClick={handleBackButton} sx={classes.backToLogin}>
              Back to Login
            </Typography>
          </Box>
        </Box>
      </>
    );
  };

  const getPasswordResetLink = () => {
    return (
      <>
        <Box sx={classes.mainContentWrapper}>
          <Grid container>
            <Grid item xs={12}>
              <Box sx={classes.contentWrapper}>
                <CustomCard cardContent={cardContent()} />
                {/* <Box>
                  <Typography sx={classes.signUpStyle}>
                    Don't have an account? <Link to="/">Sign Up Now</Link>
                  </Typography>
                </Box> */}
              </Box>
            </Grid>
            <Grid
              item
              md={12}
              lg={12}
              position={"absolute"}
              bottom={"6px"}
              width={"100%"}
            >
              <Typography textAlign={"center"} sx={classes.disclamer}>
                © 2023, Yhataw Real Estate Facilitator. All Rights Reserved.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };

  return getPasswordResetLink();
};

export default PasswordResetLink;
